import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import MetaMaskIcon from "./Wallets/MetaMask";
import WalletConnectIcon from "./Wallets/WalletConnect";
import RainbowIcon from "./Wallets/Rainbow";
import Phantom from "./Wallets/Phantom";
// All chain-specific icon sets (Starknet, TON, Solana, Fuel, Tron, Bitcoin)
// live in a lazy chunk. They are only displayed when the user is looking
// at a non-EVM connector in the connect modal or source-wallet picker —
// rarely on first paint of `/`, where the default/EVM case is the common
// one. Keeping the default 4 icons (MetaMask, WalletConnect, Rainbow,
// Phantom) inline ensures no flicker on the typical home-page render.
const LazyChainConnectorIcons = lazy(() => import(/* webpackChunkName: "connector-icons-chains" */ "./ConnectorIconsAllChains")
    .then(m => ({ default: m.ResolveConnectorIcon })));
const IconsWrapper = ({ children, className }) => {
    return _jsx("div", { className: className ?? "-space-x-2 flex", "aria-label": "Wallet type", children: children });
};
const DefaultEvmIcons = ({ iconClassName, className }) => (_jsxs(IconsWrapper, { className: className, children: [_jsx(MetaMaskIcon, { className: iconClassName }), _jsx(WalletConnectIcon, { className: iconClassName }), _jsx(RainbowIcon, { className: iconClassName }), _jsx(Phantom, { className: iconClassName })] }));
export const ResolveConnectorIcon = ({ connector, iconClassName, className, }) => {
    const lower = connector?.toLowerCase();
    // EVM and unknown/default → render inline (eager). This is the common
    // case shown on the home page swap form and the EVM tile in the modal.
    if (!lower || lower === "evm") {
        return _jsx(DefaultEvmIcons, { iconClassName: iconClassName, className: className });
    }
    // Everything else → lazy chunk with the same default icons as fallback
    // so layout doesn't shift while the chain-specific set downloads.
    return (_jsx(Suspense, { fallback: _jsx(DefaultEvmIcons, { iconClassName: iconClassName, className: className }), children: _jsx(LazyChainConnectorIcons, { connector: connector, iconClassName: iconClassName, className: className }) }));
};
